/**
 * Каталоги переводов, встроенные в сборку.
 *
 * Назначение файла: собрать JSON-файлы локалей в одну структуру, пригодную для i18next.
 * Пока язык один, всё импортируется статически — это проще и быстрее. Когда появится
 * вторая волна языков, здесь появится ленивая загрузка по namespace, чтобы игрок
 * не тянул тексты двадцати языков (docs/19-localization.md §19.4).
 *
 * Импорты: JSON-каталоги из ../locales с import attributes (требование ESM в Node 22).
 *
 * Внимание: файл namespace добавляется в двух местах — здесь и в NAMESPACES
 * в ./locales.ts. Тест i18n.test.ts проверяет, что они не разъехались.
 */

import common from "../locales/ru/common.json" with { type: "json" };
import economy from "../locales/ru/economy.json" with { type: "json" };
import errors from "../locales/ru/errors.json" with { type: "json" };
import hex from "../locales/ru/hex.json" with { type: "json" };
import hero from "../locales/ru/hero.json" with { type: "json" };
import feed from "../locales/ru/feed.json" with { type: "json" };
import quests from "../locales/ru/quests.json" with { type: "json" };
import map from "../locales/ru/map.json" with { type: "json" };
import mail from "../locales/ru/mail.json" with { type: "json" };
import onboarding from "../locales/ru/onboarding.json" with { type: "json" };
import push from "../locales/ru/push.json" with { type: "json" };
import support from "../locales/ru/support.json" with { type: "json" };
import hearth from "../locales/ru/hearth.json" with { type: "json" };
import traces from "../locales/ru/traces.json" with { type: "json" };
import { type LocaleCode, type Namespace } from "./locales.js";

/** Плоский каталог: ключ → ICU-сообщение. Вложенных объектов не используем намеренно. */
export type Catalog = Readonly<Record<string, string>>;

/** Ресурсы одной локали: namespace → каталог. */
export type LocaleResources = Partial<Readonly<Record<Namespace, Catalog>>>;

/**
 * Все встроенные ресурсы. Заполнены только те namespaces, тексты которых уже написаны;
 * остальные (`arena`, `legal` и прочие) появятся вместе с экранами.
 */
export const RESOURCES: Partial<Readonly<Record<LocaleCode, LocaleResources>>> = {
  ru: {
    common,
    economy,
    errors,
    hex,
    hero,
    feed,
    quests,
    map,
    mail,
    onboarding,
    push,
    support,
    hearth,
    traces,
  },
} as const;

/** Ресурсы локали или пустой объект, если локаль ещё не переведена. */
export function localeResources(locale: LocaleCode): LocaleResources {
  return RESOURCES[locale] ?? {};
}
